import { useRef, useState, useEffect, forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux"
import { useForm } from "react-hook-form";
import { Box } from "@mui/material";
import Typography from '@mui/material/Typography';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { usePbiFolderMutation, usePbiGetFoldersMutation } from '../features/auth/authApiSlice'
import { selectPBIWorkspace } from "../features/auth/authSlice"
import { setPBIFolderList } from "../features/data/dataSlice"
import Spinner from './Spinner'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 2,
};


const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const AddUpdateFolder = (props) => {
  const { openAddUpdateFolder, handleAddUpdateFolderClose, currentFolder, isSharedFolder, currentUserId, currentContextFolder, RenameFolder } = props;
  const pbiworkspace = useSelector(selectPBIWorkspace)
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [pbiFolderMutation, { isPbiFolderLoading }] = usePbiFolderMutation()

  const [folderName, setFolderName] = useState("");
  const [errFolder, setErrFolder] = useState("");
  const [spinnerLoad, setSpinnerLoad] = useState(false)
  const [pbiGetFoldersMutation, { isPbiGetFoldersLoading }] = usePbiGetFoldersMutation()
  const dispatch = useDispatch()

  const [errMsg, setErrMsg] = useState('')

  const methods = useForm();
  const regex = /[<>{}\[\]]/;

  const validateInput = (value) => {
    if (value && !regex.test(value)) { 
      setErrFolder("");
      return value;
    } else {
      setErrFolder("Invalid User input");
      return value;
    }
  }

  useEffect(() => {
    methods.reset({
      subscriptionname: folderName
    })
  }, [methods.reset, folderName])

  const handleAllFolders = async () => {
    const userid = { "userID": currentUserId }
    const resData = await pbiGetFoldersMutation(userid).unwrap()
    if (resData) {
      dispatch(setPBIFolderList(resData))
    }
  }

  const handleAddUpdateFolder = async (data) => {
    try {
      let isShared = isSharedFolder == 1 ? true : false
      let folderID = currentContextFolder && currentContextFolder.folderId;
      let folderData = {
        "FolderName": folderName,
        "ParentId": currentFolder.folderId,
        "TenantId": pbiworkspace,
        "IsSharedFolder": isShared
      }
      let RenamefolderData = {
        "FolderName": folderName,
        "ParentId": currentFolder.folderId,
        "TenantId": pbiworkspace,
        "IsSharedFolder": isShared,
        "FolderId": folderID
      }
      setSpinnerLoad(true);

      let reqBody = RenameFolder ? RenamefolderData : folderData;
      const response = await pbiFolderMutation(reqBody).unwrap()
      handleAllFolders(response);
      setSpinnerLoad(false);
      setOpenSnackbar(true);
      setFolderName('');
      setTimeout(() => {
        setOpenSnackbar(false);
      }, 2000);
      handleAddUpdateFolderClose();
    } catch (err) {
      if (err.status == 400) {
        setErrFolder(err.data.message);
        setSpinnerLoad(false);
        // handleAddUpdateFolderClose();
      }
    }
  }

  const onSubmitform = (data) => {
    setErrFolder("");
    handleAddUpdateFolder(data);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const handleCancelAction = (e) => {
    e.preventDefault();
    setErrFolder("");
    setFolderName('')
    handleAddUpdateFolderClose();
  }

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openAddUpdateFolder}
        onClose={handleAddUpdateFolderClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openAddUpdateFolder}>
          <Box sx={style}>
            <form onSubmit={methods.handleSubmit((d) => onSubmitform(d))}>
              <Typography id="transition-modal-title" variant="h3" component="h2">
                {props.RenameFolder ? 'Rename Folder' : 'Add Folder'}
              </Typography>
              <TextField fullWidth name="foldername"
                id="foldername"
                label="Folder Name"
                variant="filled"
                value={folderName}
                onChange={(e) => setFolderName(validateInput(e.target.value))}
                className="subscriptionformfeild"
                required={true}
                // {...methods.register("foldername", {
                //   required: "Folder name is required",
                //   validate: {
                //     minLength: (v) => v.length >= 1
                //   },
                // })}
                 />
              <Box>
                {/* {methods.formState?.errors?.foldername?.message && (
                  <span className="error-message">{methods.formState.errors.foldername.message}</span>
                )} */}
                {errFolder && (<span className="error-message">{errFolder}</span>)}
              </Box>
              <Stack className="divlogoutbtn" direction="row" spacing={2}>
                <Button type="submit" variant="contained" color="primary"
                disabled={folderName === '' || errFolder !== ''}>Save</Button>
                <Button variant="outlined" color="primary" onClick={(e) => handleCancelAction(e)}>Cancel</Button>
              </Stack>
            </form>
          </Box>
        </Fade>
      </Modal>
      <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }}>
          Saved succussfully
        </Alert>
      </Snackbar>
      {spinnerLoad && (<Spinner />)}
    </>
  );
};

export default AddUpdateFolder;
